import { twMerge } from 'tailwind-merge';
import type { DecoratedFileCollection } from '@witmetrics/utils';
import { useToggle } from '@/hooks/useToggle';
import { ListItem } from '@/components/List';
import MoveButton from '../MoveButton';
import { classes, styles } from './utils';

export type CollectionListItemProps = {
  disabled?: boolean;
  fileCollection: DecoratedFileCollection;
  onOpen: () => void;
  onSave: () => Promise<void>;
};

export default function CollectionListItem({
  disabled,
  fileCollection,
  onOpen,
  onSave,
}: CollectionListItemProps) {
  const [isSaving, toggleSaving] = useToggle();

  const handleMove = async () => {
    toggleSaving(true);
    await onSave();
    toggleSaving(false);
  };

  return (
    <ListItem
      sx={styles.listItem}
      className={twMerge(classes.listItem, isSaving && classes.saving)}
      label={
        <button disabled={disabled} className={classes.name} onClick={onOpen}>
          {fileCollection.name}
        </button>
      }
      actions={
        <MoveButton
          disabled={disabled}
          isSaving={isSaving}
          onMove={handleMove}
        />
      }
    />
  );
}
